import { Skeleton } from '@/components/custom';

type TProps = {
	count?: number;
};

const DataTableMobileSkeleton = ({ count = 5 }: TProps) => (
	<div className="space-y-4">
		{Array.from({ length: count }).map((_, i) => (
			<div key={i} className="p-4 border rounded-lg bg-card text-card-foreground shadow-xs">
				<div className="flex items-start justify-between gap-3">
					<div className="space-y-2 flex-1">
						<Skeleton className="h-4 w-32" />
						<Skeleton className="h-3 w-14" />
					</div>
					<div className="flex flex-col items-end space-y-2">
						<Skeleton className="h-5 w-16 rounded-full" />
						<Skeleton className="h-3 w-24" />
						<Skeleton className="h-3 w-20" />
					</div>
				</div>
			</div>
		))}
	</div>
);

export default DataTableMobileSkeleton;
